export default {
  shared: {
    appVersion: "Versione app",
    brand: "Marca",
  },
  assignBeforePairing:
    "Assegna questo dispositivo a una struttura prima di collegare un lettore",
  deviceRevoked: "Dispositivo revocato",
  deviceReactivated: "Dispositivo riattivato",
  deviceShelved: "Dispositivo parcheggiato",
  deviceUnshelved: "Dispositivo rimesso in campo",
  credentialsRegenerated: "Credenziali rigenerate",
  kioskAssigned: "Dispositivo assegnato con successo",
  readerUpdated: "Lettore aggiornato",
  deviceRenamed: "Nome visualizzato aggiornato",
  deviceGoogleAccountUpdated: "Account Google aggiornato",
  deviceNotesUpdated: "Note aggiornate",
  page: {
    kpiTotal: "Dispositivi attivi",
    kpiTotalHint: "Esclusi i revocati",
    kpiOnline: "Online",
    kpiOnlineHint: "Telemetria completa nelle ultime 20 h",
    kpiIncomplete: "Configurazione incompleta",
    kpiIncompleteHint: "Manca abbinamento, lettore o struttura",
    kpiShelved: "Parcheggiati",
    kpiShelvedHint: "Non in campo",
    title: "Gestione dispositivi",
    subtitle: "Gestisci i dispositivi delle strutture",
    newDevice: "Nuovo dispositivo",
    tabDevices: "Dispositivi",
    tabPresets: "Preset dispositivo",
    searchPlaceholder: "Cerca per nome, codice, struttura o altro…",
    filterActiveLabel: "Attivo",
    filterActiveAll: "Tutti",
    filterActiveActive: "Attivi",
    filterActiveInactive: "Inattivi",
    filterSetupLabel: "Configurazione",
    filterSetupAll: "Tutti",
    filterSetupComplete: "Completi",
    filterSetupIncomplete: "Incompleti",
    filterSetupRevoked: "Revocati",
    filterShelvedLabel: "Parcheggio",
    filterShelvedAll: "Tutti",
    filterShelvedInService: "In campo",
    filterShelvedOnly: "Parcheggiati",
    filterTelemetryLabel: "Stato telemetria",
    filterTelemetryAll: "Tutti",
    filterTelemetryGray: "Non associato",
    filterTelemetryGreen: "Completa",
    filterTelemetryYellow: "Incompleta",
    filterTelemetryRed: "Nessun dato (> 20 h)",
    filterAppVersionAny: "Qualsiasi",
    filterAppVersionCount: "{{count}} selezionate",
    filterIncompleteMissingLabel: "Dettaglio configurazione incompleta",
    filterIncompleteMissingAny: "Qualsiasi",
    filterIncompleteMissingCount: "{{count}} selezionati",
    filterMissingBinding: "Manca chiave software",
    filterMissingReader: "Manca lettore",
    filterMissingStructure: "Manca struttura",
    telemetryTooltipGray: "Mai connesso o non associato",
    telemetryTooltipGreen: "Telemetria completa",
    telemetryTooltipYellow: "Telemetria incompleta",
    telemetryTooltipRed: "Nessuna telemetria (> 20 h)",
    setupBadgeIncomplete: "Incompleto",
    setupBadgeRevoked: "Revocato",
    setupBadgeIncompleteTooltipTitle: "Manca ancora:",
    setupBadgeIncompleteTooltipDesc:
      "Questo dispositivo non può accettare pagamenti finché la configurazione non è completa.",
    setupBadgeRevokedTooltip: "Questo dispositivo è stato revocato",
    setupMissingBinding: "Associazione chiave software",
    setupMissingBindingDesc:
      "Il tablet deve accedere almeno una volta con la propria chiave software.",
    setupMissingPairing: "Collegamento lettore di pagamento",
    setupMissingPairingDesc:
      "È necessario collegare un lettore di pagamento a questo tablet per elaborare i pagamenti con carta.",
    setupMissingAssignment: "Assegnazione a struttura",
    setupMissingAssignmentDesc:
      "Il dispositivo deve essere assegnato a una struttura host.",
    colDevice: "Nome visualizzato",
    colSerial: "S/N",
    colGoogleAccount: "Account Google",
    colFreekioskUnlock: "Sblocco FK",
    colReader: "Lettore",
    colHouse: "Struttura",
    colLastTelemetry: "Ultima telemetria",
    colLastInteraction: "Ultima interazione",
    colInUse: "In campo",
    colActions: "Azioni",
    selectRow: "Seleziona {{name}}",
    selectAllFiltered: "Seleziona tutti i {{count}} filtrati",
    exportCsv: "Esporta CSV",
    emptySearch: "Nessun dispositivo corrisponde alla ricerca.",
    emptyDefault: "Nessun dispositivo. Creane uno per iniziare.",
    readerPair: "Collega",
    readerUnpairTitle: "Scollega lettore",
    readerUnpairConfirm:
      "Scollegare questo lettore dal tablet? L'abbinamento SumUp rimane; i pagamenti resteranno disabilitati finché non lo colleghi di nuovo.",
    readerUnpaired: "Lettore scollegato",
    houseOpenTitle: "Apri struttura",
    houseRemoveTitle: "Rimuovi struttura dal dispositivo",
    houseRemoveConfirm:
      "Rimuovere «{{name}}» da questo dispositivo? Diventerà non assegnato.",
    houseRemoved: "Struttura rimossa",
    assign: "Assegna",
    moreActionsTitle: "Altre azioni",
    regenerateConfirm:
      "Rigenerare la password di «{{name}}»? Le sessioni tablet esistenti non saranno più valide.",
    credentialModalTitle: "Credenziali rigenerate",
    credentialModalDesc:
      "La password è stata rigenerata. Salva subito queste credenziali: la password viene mostrata una sola volta.",
    statusPartial: "Parzialmente configurato",
    assignModalTitle: "Assegna dispositivo",
    assignModalIntro: "Assegna {{name}} a un host e a una struttura.",
    selectHostStep: "1) Seleziona host",
    selectHouseStep: "2) Seleziona struttura",
    searchHostsPlaceholder: "Cerca host…",
    searchHousesPlaceholder: "Cerca strutture…",
    searchHousesDisabledPlaceholder: "Prima seleziona un host…",
    noHostsFound: "Nessun host trovato.",
    pickHostForHouses: "Scegli un host per vedere le sue strutture.",
    noHousesFound: "Nessuna struttura trovata.",
    noAddressSet: "Nessun indirizzo",
    assignedDevicesLabel: "Dispositivi assegnati:",
    assignSubmit: "Assegna",
    otherInfoTitle: "Altre informazioni sul dispositivo",
    fieldDisplayName: "Nome visualizzato",
    fieldKioskCode: "Codice dispositivo",
    fieldSerialNumber: "Numero di serie",
    fieldSoftwareId: "ID software",
    fieldGoogleAccount: "Account Google",
    fieldReaderId: "ID lettore",
    fieldDisplayInches: "Pollici display",
    fieldResolution: "Risoluzione",
    fieldAndroidVersion: "Versione Android",
    valueAppVersionUnknown: "Sconosciuta",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Note",
    notesPlaceholder: "Aggiungi una nota…",
    fieldLastTelemetryReport: "Ultima telemetria ricevuta",
    sectionTelemetryData: "Dati telemetria",
    sectionTelemetryDeviceStatus: "Stato dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Posizione (GPS del dispositivo)",
    valueTelemetryNever: "Mai",
    valueTelemetryEmpty: "Nessun dato ancora",
    fieldHouse: "Struttura",
    valueUnbound: "Non associato",
    valueNotPaired: "Non collegato",
    valueUnassigned: "Non assegnato",
    menuRegenerateCredentials: "Rigenera credenziali",
    menuRevokeDevice: "Revoca credenziali",
    menuReactivateDevice: "Riattiva credenziali",
    menuNotes: "Note",
    menuOtherInfo: "Altre informazioni",
    renameDeviceTitle: "Modifica nome visualizzato",
    displayNamePlaceholder: "Nome visualizzato",
    displayNameEmpty: "Il nome visualizzato non può essere vuoto",
    editGoogleAccountTitle: "Modifica account Google",
    telemetryBattery: "Batteria",
    telemetryWifi: "Segnale WiFi",
    telemetryAudio: "Volume audio",
    telemetryStorage: "Archivio usato",
    telemetryMemory: "RAM usata",
    telemetryUnavailable: "-",
    telemetryDataAge: "Dati di {{age}}",
  },
  createModal: {
    titleCreate: "Crea nuovo dispositivo",
    titleCreated: "Dispositivo creato!",
    hardwareIdLabel: "ID hardware (S/N o IMEI)",
    hardwareIdPlaceholder: "es. 359881234567890",
    hardwareIdRequired: "Inserisci un ID hardware (S/N o IMEI)",
    googleAccountLabel: "Account Google",
    googleAccountPlaceholder: "es. tablet@azienda.com",
    googleAccountRequired: "Inserisci l'email dell'account Google",
    displayNameLabel: "Nome visualizzato (facoltativo)",
    displayNamePlaceholder: "es. Tablet reception",
    presetSelectorTitle: "Scegli un preset di dispositivo",
    presetsEmpty:
      "Nessun preset trovato. Puoi crearne uno dalla pagina dei preset di dispositivo oppure usare la modalità manuale qui sotto.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired:
      "Seleziona un preset di dispositivo o passa alla modalità manuale",
    manualToggle: "Inserisci i dettagli hardware manualmente",
    brandPlaceholder: "es. Samsung",
    androidVersionLabel: "Versione Android",
    androidVersionPlaceholder: "es. 14",
    resolutionLabel: "Risoluzione display",
    resolutionPlaceholder: "es. 1920x1200",
    inchesLabel: "Pollici display",
    inchesPlaceholder: "es. 10.1",
    inchesInvalid: "I pollici del display devono essere un numero valido",
    submit: "Crea dispositivo",
    successTitle: "Dispositivo creato con successo!",
    successDescription:
      "Usa queste credenziali per accedere dal tablet. Non verranno mostrate di nuovo.",
    deviceNameLabel: "Nome dispositivo",
    modelLabel: "Modello",
    modelPlaceholder: "es. Tab A9",
    kioskCodeLabel: "Codice dispositivo",
    passwordLabel: "Password",
    qrHelp:
      "Scansiona questo QR dalla schermata di login del tablet per inserire automaticamente le credenziali.",
    importantLabel: "Importante:",
    importantDescription:
      "Salva ora queste credenziali. Chiunque scansioni il QR potrà accedere finché non rigeneri la password.",
  },
  presets: {
    validationRequired: "Tutti i campi sono obbligatori",
    validationDisplayInches:
      "I pollici del display devono essere un numero valido maggiore di zero",
    created: "Preset creato",
    updated: "Preset aggiornato",
    deleted: "Preset eliminato",
    deleteConfirm: "Eliminare il preset «{{name}}»?",
    brandPlaceholder: "Marca (es. TCL)",
    modelPlaceholder: "Modello (es. TAB 10L)",
    androidVersionPlaceholder: "Versione Android (es. 15)",
    resolutionPlaceholder: "Risoluzione (es. 800x1280)",
    inchesPlaceholder: "Pollici (es. 10.1)",
    save: "Salva preset",
    add: "Aggiungi preset",
    colModel: "Modello",
    colAndroid: "Android",
    colResolution: "Risoluzione",
    colInches: "Pollici",
    inchesValue: "{{inches}}″",
    colActions: "Azioni",
    empty: "Nessun preset ancora.",
    editTitle: "Modifica preset",
    deleteTitle: "Elimina preset",
  },
} as const;
